import { jsx } from "react/jsx-runtime";
import Icon from "../../graphics/Icon/Icon.js";
const resolveType = (props) => {
  switch (props.type) {
    case "error":
      return {
        title: props.title || "Error!",
        color: "error",
        icon: /* @__PURE__ */ jsx(Icon, { name: "X", color: "light" })
      };
    case "warning":
      return {
        title: props.title || "Waning!",
        color: "warning",
        icon: /* @__PURE__ */ jsx(Icon, { name: "AlertCircle", color: "light" })
      };
    case "success":
      return {
        title: props.title || "Success!",
        color: "success",
        icon: /* @__PURE__ */ jsx(Icon, { name: "CircleCheck", color: "light" })
      };
    case "important":
      return {
        title: props.title || "Important!",
        color: "information",
        icon: /* @__PURE__ */ jsx(Icon, { name: "InfoCircle", color: "light" })
      };
    default:
      return {
        title: props.title,
        color: "information",
        icon: props.icon && /* @__PURE__ */ jsx(Icon, { name: props.icon, color: "light" })
      };
  }
};
export {
  resolveType
};
